export default __webpack_public_path__ + "static/media/phyllispayne.e588cbf0.jpg";